/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Feat2_BodyInputs */

const es_exp_mk_feat2_body = /** @type {(inputs: Exp_Mk_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te unes al grupo y compartes el coste de la jornada. Sin sorpresas.`)
};

const gl_exp_mk_feat2_body = /** @type {(inputs: Exp_Mk_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úneste ao grupo e compartes o custo da xornada. Sen sorpresas.`)
};

const en_exp_mk_feat2_body = /** @type {(inputs: Exp_Mk_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the group and share the day's costs. No surprises.`)
};

/**
* | output |
* | --- |
* | "Join the group and share the day's costs. No surprises." |
*
* @param {Exp_Mk_Feat2_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_feat2_body = /** @type {((inputs?: Exp_Mk_Feat2_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Feat2_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_feat2_body(inputs)
	if (locale === "en") return en_exp_mk_feat2_body(inputs)
	return es_exp_mk_feat2_body(inputs)
});